import { render } from "./MyPerformance.vue?vue&type=template&id=376911e3&scoped=true&lang=pug"
import script from "./MyPerformance.vue?vue&type=script&lang=js"
export * from "./MyPerformance.vue?vue&type=script&lang=js"

import "./MyPerformance.vue?vue&type=style&index=0&id=376911e3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-376911e3"]])

export default __exports__